import { SystemProps, Text } from "flicket-ui";

import { pick } from "@styled-system/props";

const alertMessageDefaults = ["Back office order"] as const;

interface HeaderAlertProps extends SystemProps {
  fixed: boolean;
  message:
    | typeof alertMessageDefaults[number]
    | (string & Record<string, never>);
}

function HeaderAlert({ message, fixed, ...props }: HeaderAlertProps) {
  return (
    <Text
      py="1/2"
      px={2}
      bg="S300"
      color="white"
      textAlign="center"
      fontWeight="extraBold"
      w="100%"
      // Position alert as fixed on desktop but scrollable on mobile
      position={{ _: "static", md: fixed ? "fixed" : "static" }}
      top={{ _: "unset", md: fixed ? "63px" : "unset" }}
      left={{ _: "unset", md: fixed ? "0" : "unset" }}
      // Navbar zindex is 1100.
      zIndex={1000}
      {...pick(props)}
    >
      {message}
    </Text>
  );
}

export default HeaderAlert;
